import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { addSubmitSuggestionFeedbackAnalytics } from '../ui/utils/analytics';

import type { SubmitSuggestionFeedbackAction } from './types';

/**
 * Submit user feedback (good / bad) for a suggestion.
 *
 * TODO(EDITOR-8148): This is currently a placeholder. It resolves the suggestion
 * and fires an analytics event, but does not yet send the feedback anywhere
 * (endpoint / product provider callback). Wire that up once the destination is
 * finalised.
 */
export const submitSuggestionFeedbackAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => SubmitSuggestionFeedbackAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(id, sentiment, options): boolean => {
		let found = false;
		api?.core?.actions.execute(({ tr }) => {
			const pluginState = api?.aiSuggestions?.sharedState.currentState();
			const suggestion = pluginState?.suggestionById.get(id);
			if (!suggestion) {
				return tr;
			}
			found = true;
			addSubmitSuggestionFeedbackAnalytics(api?.analytics?.actions)(
				tr,
				suggestion,
				sentiment,
				options?.interactionPoint ?? 'card',
			);
			return tr;
		});
		return found;
	};
